// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { BenefitGrantOperationsService } from '../generated/api/benefitGrantOperations.service';

@Injectable({ providedIn: 'root' })
export class BenefitGrantOperationsClientService {
  constructor(private readonly client: BenefitGrantOperationsService) {}
  // <generated-client-wrappers:methods>
  get(
    grantId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AdministrativeBenefitGrantResponse> {
    if (!this.client)
      throw new Error('BenefitGrantOperationsService is not available');
    return this.client.benefitGrantOperationsGet(
      grantId,
      'body',
      reportProgress,
      options,
    );
  }

  getByRequest(
    requestId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AdministrativeBenefitGrantResponse> {
    if (!this.client)
      throw new Error('BenefitGrantOperationsService is not available');
    return this.client.benefitGrantOperationsGetByRequest(
      requestId,
      'body',
      reportProgress,
      options,
    );
  }

  getMeters(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.ServiceBenefitMeterResponse>> {
    if (!this.client)
      throw new Error('BenefitGrantOperationsService is not available');
    return this.client.benefitGrantOperationsGetMeters(
      'body',
      reportProgress,
      options,
    );
  }

  getRevocation(
    grantId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AdministrativeBenefitRevocationResponse> {
    if (!this.client)
      throw new Error('BenefitGrantOperationsService is not available');
    return this.client.benefitGrantOperationsGetRevocation(
      grantId,
      'body',
      reportProgress,
      options,
    );
  }

  getRevocationByRequest(
    requestId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AdministrativeBenefitRevocationResponse> {
    if (!this.client)
      throw new Error('BenefitGrantOperationsService is not available');
    return this.client.benefitGrantOperationsGetRevocationByRequest(
      requestId,
      'body',
      reportProgress,
      options,
    );
  }

  grant(
    request: WrapperApi.AdministrativeBenefitGrantRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AdministrativeBenefitGrantResponse> {
    if (!this.client)
      throw new Error('BenefitGrantOperationsService is not available');
    return this.client.benefitGrantOperationsGrant(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  revoke(
    grantId: string,
    request: WrapperApi.AdministrativeBenefitRevocationRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AdministrativeBenefitRevocationResponse> {
    if (!this.client)
      throw new Error('BenefitGrantOperationsService is not available');
    return this.client.benefitGrantOperationsRevoke(
      grantId,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
